/* 9thara · Saree Origin game engine — vanilla JS, no dependencies.
   Handles round shuffling, option shuffling, scoring, reveal, final result, share.
   Rounds are rendered by Liquid into `data-round-index` sections; JS only orchestrates. */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var gameRoot = document.querySelector('[data-game-root]');
    if (!gameRoot) return;

    var TOTAL_ROUNDS = 10;
    var allRounds = Array.prototype.slice.call(gameRoot.querySelectorAll('.nine-game-round'));
    var final     = gameRoot.querySelector('[data-final]');
    var currentRoundEl = gameRoot.querySelector('[data-current-round]');
    var scoreEl        = gameRoot.querySelector('[data-current-score]');
    var progressFill   = gameRoot.querySelector('[data-progress-fill]');

    var state = {
      selectedRounds: [],
      currentIndex:   0,
      score:          0,
      answers:        []
    };

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
      }
      return a;
    }

    function initGame() {
      // Reset all round visibility
      allRounds.forEach(function (r) { r.setAttribute('aria-hidden', 'true'); });
      if (final) final.setAttribute('aria-hidden', 'true');

      state.selectedRounds = shuffle(allRounds).slice(0, TOTAL_ROUNDS);
      state.currentIndex   = 0;
      state.score          = 0;
      state.answers        = [];

      // Shuffle options inside each selected round (fresh each session)
      state.selectedRounds.forEach(function (round) {
        var optsContainer = round.querySelector('.nine-game-options');
        if (!optsContainer) return;
        var opts = Array.prototype.slice.call(optsContainer.querySelectorAll('.nine-game-option'));
        var shuffledOpts = shuffle(opts);
        shuffledOpts.forEach(function (o) { optsContainer.appendChild(o); });
        // Reset states
        opts.forEach(function (o) {
          o.disabled = false;
          o.classList.remove('is-correct', 'is-wrong');
        });
        var reveal = round.querySelector('[data-reveal]');
        if (reveal) reveal.hidden = true;
      });

      showRound(0);
      updateScoreDisplay();
    }

    function showRound(idx) {
      if (idx >= state.selectedRounds.length) {
        showFinal();
        return;
      }
      var round = state.selectedRounds[idx];
      // Hide all rounds, show target
      state.selectedRounds.forEach(function (r) { r.setAttribute('aria-hidden', 'true'); });
      round.setAttribute('aria-hidden', 'false');

      // Scroll into view (mobile flow)
      requestAnimationFrame(function () {
        round.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Update progress
      if (currentRoundEl) currentRoundEl.textContent = (idx + 1);
      if (progressFill) progressFill.style.width = ((idx + 1) / state.selectedRounds.length * 100) + '%';
    }

    function updateScoreDisplay() {
      if (scoreEl) scoreEl.textContent = state.score;
    }

    function handleOptionClick(e) {
      var btn = e.target.closest('.nine-game-option');
      if (!btn || btn.disabled) return;
      var round = btn.closest('.nine-game-round');
      if (!round) return;

      var isCorrect = btn.getAttribute('data-correct') === 'true';
      state.answers.push({
        region: round.getAttribute('data-region'),
        chose: btn.getAttribute('data-option-value'),
        correct: isCorrect
      });

      // Mark all options
      var opts = round.querySelectorAll('.nine-game-option');
      Array.prototype.forEach.call(opts, function (o) {
        o.disabled = true;
        if (o.getAttribute('data-correct') === 'true') o.classList.add('is-correct');
      });
      if (!isCorrect) btn.classList.add('is-wrong');

      if (isCorrect) {
        state.score++;
        updateScoreDisplay();
      }

      // Reveal panel
      var reveal = round.querySelector('[data-reveal]');
      if (reveal) {
        var verdictEl = reveal.querySelector('[data-reveal-verdict]');
        if (verdictEl) {
          verdictEl.textContent = isCorrect
            ? '✓ Correct'
            : ('✗ Not quite — the answer is ' + round.getAttribute('data-correct-answer'));
          verdictEl.setAttribute('data-verdict', isCorrect ? 'correct' : 'wrong');
        }
        reveal.hidden = false;
      }
    }

    function handleNext(e) {
      var btn = e.target.closest('[data-next]');
      if (!btn) return;
      state.currentIndex++;
      showRound(state.currentIndex);
    }

    function showFinal() {
      state.selectedRounds.forEach(function (r) { r.setAttribute('aria-hidden', 'true'); });
      if (!final) return;
      final.setAttribute('aria-hidden', 'false');

      var pct = Math.round(state.score / state.selectedRounds.length * 100);
      var heading = final.querySelector('[data-final-heading]');
      var tagline = final.querySelector('[data-final-tagline]');

      if (heading) heading.textContent = 'You scored ' + state.score + ' / ' + state.selectedRounds.length;

      var msg = '';
      if (pct === 100)      msg = 'Perfect! You know your weaves — the ancestors are proud.';
      else if (pct >= 80)   msg = 'Excellent — you have the eye of a saree connoisseur.';
      else if (pct >= 60)   msg = 'Good work! Read the region deep-dives to sharpen the eye.';
      else if (pct >= 40)   msg = 'A start — the fifteen regions below will teach you the rest.';
      else                  msg = 'Every expert began as a curious learner. Explore the region pages to build the eye.';
      if (tagline) tagline.textContent = msg;

      setupShare();

      requestAnimationFrame(function () {
        final.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function setupShare() {
      var pageUrl = window.location.origin + window.location.pathname;
      var shareText = 'I scored ' + state.score + '/' + state.selectedRounds.length + ' on the 9thara Guess the Saree Origin quiz. Beat me?';
      var encoded   = encodeURIComponent(shareText + ' ' + pageUrl);
      var urlOnly   = encodeURIComponent(pageUrl);
      var textOnly  = encodeURIComponent(shareText);

      var wa = final.querySelector('[data-share-whatsapp]');
      var tw = final.querySelector('[data-share-twitter]');
      var fb = final.querySelector('[data-share-facebook]');
      var cp = final.querySelector('[data-share-copy]');

      if (wa) wa.href = 'https://wa.me/?text=' + encoded;
      if (tw) tw.href = 'https://twitter.com/intent/tweet?text=' + textOnly + '&url=' + urlOnly;
      if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + urlOnly + '&quote=' + textOnly;
      if (cp) {
        cp.onclick = function () {
          var label = cp.querySelector('[data-copy-label]');
          if (navigator.clipboard) {
            navigator.clipboard.writeText(shareText + ' ' + pageUrl).then(function () {
              if (label) label.textContent = 'Copied!';
              setTimeout(function () { if (label) label.textContent = 'Copy'; }, 1600);
            });
          }
        };
      }

      // Discount code copy button
      var discBtn  = final.querySelector('[data-discount-copy]');
      var discCode = final.querySelector('[data-discount-code]');
      if (discBtn && discCode) {
        discBtn.onclick = function () {
          var label = discBtn.querySelector('[data-discount-copy-label]');
          var code = discCode.textContent.trim();
          if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(function () {
              discBtn.classList.add('is-copied');
              if (label) label.textContent = '✓ Copied';
              setTimeout(function () {
                discBtn.classList.remove('is-copied');
                if (label) label.textContent = 'Copy code';
              }, 2000);
            });
          }
        };
      }
    }

    function handleRestart(e) {
      if (!e.target.closest('[data-restart]')) return;
      initGame();
    }

    // Event delegation
    gameRoot.addEventListener('click', function (e) {
      if (e.target.closest('.nine-game-option')) return handleOptionClick(e);
      if (e.target.closest('[data-next]'))       return handleNext(e);
      if (e.target.closest('[data-restart]'))    return handleRestart(e);
    });

    initGame();
  });
})();
